import { getCoupleDisplayFullName } from "./getCoupleDisplayName";

const getClientDisplayName = (client: PatientChartResponseEntry) => {
  const isCouple = client.couple_members && client.couple_members.length > 0;

  if (isCouple) {
    return getCoupleDisplayFullName(client.couple_members);
  }

  return `${
    // client.patient.preferred_first_name ||
    client.patient.first_name
  } ${client.patient.last_name || ""}`;
};

export default getClientDisplayName;
